import { VideoState } from '../types/api';
import type { VideoResponse } from '../types/api';

// A shared video is Unsealed with no sealedAt. The server keeps sealedAt on anything that was
// ever sealed, so a video the family voted open is never mistaken for a shared one.
export function isSharedVideo(v: Pick<VideoResponse, 'state' | 'sealedAt'>): boolean {
  return v.state === VideoState.Unsealed && !v.sealedAt;
}

// Every word must appear somewhere in the title or description, in any order.
export function filterVideos<T extends Pick<VideoResponse, 'title' | 'description'>>(
  videos: T[],
  query: string,
): T[] {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return videos;
  return videos.filter(v => {
    const haystack = `${v.title} ${v.description ?? ''}`.toLowerCase();
    return words.every(w => haystack.includes(w));
  });
}
